import { axiosInstance as axios } from "services";

export const deleteSeriesCarting = async (id) => {
  const { data } = await axios.delete(`/pricing/master/carting/${id}`);
  if (!data.success) throw new Error(data.error?.message || "Failed to delete carting");
  return data;
};

